import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Privilege } from '../models/privilege.model';
import { RoleService } from '../services/role.service';
@Component({
  selector: 'app-specialization',
  templateUrl: './specialization.component.html'
})
export class SpecializationComponent {
  constructor(private service: RoleService, private router: Router) { }

  ngOnInit() {
    /*if (!this.service.isAuthorized(Privilege.Specialization))
      this.router.navigate(['']);*/
  }
}
